exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".report[data-v-157ef01c]{width:90%;border:1px solid #ddd;text-align:center;font-size:13px}.report .header[data-v-157ef01c]{font-size:16px;padding:20px 0}.report .body[data-v-157ef01c]{border-bottom:1px solid #ddd}.report .body .td[data-v-157ef01c]{border:1px solid #ddd;border-left:none;border-bottom:none;padding:2px 0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.report .body .td.no-br[data-v-157ef01c]{border-right:none}.report .body .td.no-bt[data-v-157ef01c]{border-top:none}.report .body .td.bg[data-v-157ef01c]{background-color:#f3b084}.report .footer[data-v-157ef01c]{padding:20px 0;text-align:left}.no-data[data-v-157ef01c]{padding:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-157ef01c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/views/report/trade.vue
// module id = 461
// module chunks = 0